<template>
  <v-card class="" elevation="0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="12" md="4" lg="3">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select solo :items="allMethods()" v-model="methodName" @input="methodFilter" append-icon="mdi-chevron-down"
          label="Payment methods" class="custom-select" item-text="method_name" item-value="pretty_name"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select solo :items="slots" append-icon="mdi-chevron-down" label="All Status" class="custom-select"
          v-model="selectedStatus" @change="onStatusChange"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="2">
        <ul>
          <li class="mr-3 mr-lg-0">
            <span class="text--red">Total Transfers:</span>
            <span class="text-right">${{ formattedAllNumber(transferAmount) }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable depositTableForTransaction"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="internaltransfers" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </router-link>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-else>
                <span class="text-capitalize text--ash">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </span>
              </template>
              <template v-slot:item.trx_type="{ item }">
                <div class="d-flex align-items-center">
                  <v-icon color="#B4C2D1" small :class="verifyIcon(item.trx_type)"></v-icon>
                  <span>{{ item.trx_type }}</span>
                </div>
              </template>
              <template v-slot:item.account_email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.account_email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.account_email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.status="{ item }">
                <div class="status-selection">
                  <v-select solo :items="updateslots"
                    :append-icon="item.status === 1 ? 'mdi-checkbox-marked-circle' : item.status === 2 ? 'mdi-cancel' : 'mdi-chevron-down'"
                    class="custom-select" v-model="item.status" item-text="statusText" item-value="status"
                    :disabled="item.status > 0 || $canRoute('internal-transctions') !== 1" @change="onUpdateChange(item)">
                    <template v-slot:selection="{ item }">
                      <div :class="getTextColor(item)">
                        {{
                          item.status === 0
                            ? "Pending"
                            : item.status === 1
                              ? "Approved"
                              : item.status === 2
                                ? "Rejected"
                                : null
                        }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTIONS__ACTIONS } from "@/store/action-types";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      slots: ["All", "Pending", "Approved", "Rejected"],
      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approved" },
        { status: 2, statusText: "Rejected" },
      ],
      selectedStatus: null,
      modal: false,
      dialog: false,
      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "From Account", value: "from_account" },
        { text: "To Account", value: "trading_account_no" },
        { text: "Status", value: "status" },
        { text: "Amount", value: "amount" },
      ],
      isCopied: false,
      copiedStates: {},
      methodName: null,
      showRejectionCauseSection: false,
      selectedFile: null,
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},
      date: null
    };
  },
  computed: {
    ...mapState("trxinternal", [
      "internaltransfers",
      "totalCount",
      "isLoading",
      "paymentMethods",
      "transferAmount",
      "pagination",
      "range",
    ]),

    isItOpen() {
      return function (item) {
        return item?.status !== 2;
      };
    },
  },
  methods: {
    formatMySQLDate,
    ...mapActions("trxinternal", [
      TRANSACTIONS__ACTIONS.TRXINTERNALTRANSFER,
      TRANSACTIONS__ACTIONS.UPDATEDEPOSIT,
    ]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    downloadFile(fileUrl) {
      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = true;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    openInNewTab(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    handleFile(item) {
      this.selectedFile = item;
    },

    handleDepositApprove(item) {
      let parameter = {
        id: item?.id,
        status: 1,
        remarks: this.remarks,
      };
      this[TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](parameter);
    },

    handleOpenRejected() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleCloseRejected() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    handleDepositConfrimRejected(item) {
      let parameter = {
        id: item?.id,
        status: 2,
        reason: this.reason || this.selectedReason || "N/A",
      };
      this[TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](parameter);
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
      this.reason = null;
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
    },

    allMethods() {
      return [{ id: "All", method_name: "All" }, ...this.paymentMethods];
    },

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
        method_name: this.methodName === "All" ? null : this.methodName,
        status: this.selectedStatus === "All"
          ? null
          : this.selectedStatus === "Pending"
            ? "0"
            : this.selectedStatus === "Approved"
              ? 1
              : this.selectedStatus === "Rejected"
                ? 2
                : null
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[TRANSACTIONS__ACTIONS.TRXINTERNALTRANSFER](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    methodFilter() {
      this.options.page = 1;
      this.fetchData();
    },

    onStatusChange() {
      this.page = 1;
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },

    onUpdateChange(item) {
      let parameter = {
        id: item?.id,
        status: item.status,
      };
      this[TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](parameter);
    },

    getColor(item) {
      return item.color;
    },

    getTextColor(item) {
      return item.status === 1
        ? "text-approved"
        : item.status === 2
          ? "text-decline"
          : "text-pending";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
  },
  watch: {
    range: {
      immediate: true,
      handler(r) {
        if (!r?.start || !r?.end) return;

        // prevent overriding user-selected dates
        if (this.selectedDatesText) return;

        this.selectedDates = [r.start, r.end];
        this.selectedDatesText = `${r.start} ~ ${r.end}`;
      }
    }
  },

  async created() {
    await this.fetchData();
  },
};
</script>
